import type { Context } from 'react';
import { createContext } from 'react';

import type { ContentModeFragmentProvider_content$data } from '../components/__generated__/ContentModeFragmentProvider_content.graphql.ts';

export const ContentModeFragmentContext: Context<ContentModeFragmentProvider_content$data | null> =
	createContext<ContentModeFragmentProvider_content$data | null>(null);
